/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsChatConfigurationComponent = EntryPointComponent<
	Record<string, OperationType>,
	{},
	{},
	{} | null
>;

export const HelpCenterSettingsChatConfiguration: EntryPoint<
	HelpCenterSettingsChatConfigurationComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterSettingsChatConfigurationComponent>(
		/* webpackChunkName: "async-help-center-settings-chat-configuration-app" */ './HelpCenterSettingsChatConfigurationApp.tsx',
	),
	getPreloadProps: () => ({}),
});
